export default "__VITE_ASSET__05710aca__"